import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../services/auth.service';

interface Role {
  name: string;
  code: string;
}

@Component({
  selector: 'app-quotation-register',
  templateUrl: './quotation-register.component.html',
  styleUrls: ['./quotation-register.component.scss'],
  providers: [MessageService]
})
export class QuotationRegisterComponent implements OnInit {
  registerForm!: FormGroup;
  roles: Role[] = [
    { name: 'Superadmin', code: 'superadmin' },
    { name: 'Admin', code: 'admin' },
    { name: 'Company User', code: 'companyUser' }
  ];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      employeeNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{1,10}$/)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      role: [null, Validators.required]
    });
  }

  onSubmit(): void {
    if (this.registerForm.valid) {
      this.authService.registerUser(this.registerForm.value).subscribe({
        next: (response) => {
          console.log('Form Submitted', response);
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Registration successful!'
          });
          this.registerForm.reset();
        },
        error: (err) => {
          console.error('Registration error', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error.error || 'Registration failed. Please try again.'
          });
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill all required fields correctly.'
      });
    }
  }
}